import { LicenseFeature } from '../../types';

export const businessSpecificFeatures: LicenseFeature[] = [
  { name: 'Bookings', included: false },
  { name: 'MileIQ', included: false },
  { name: 'Microsoft Defender for Business', included: false },
  { name: 'Microsoft Entra ID P1', included: false },
  { name: 'Business Voice', included: false },
  { name: 'Power Apps for Business', included: false },
  { name: 'Power Automate for Business', included: false },
  { name: 'URL time-of-click protection', included: false },
  { name: 'Copilot Chat enhancements', included: false },
  { name: 'Copilot Chat Analytics', included: false },
  { name: 'Microsoft Teams', included: false },
  { name: 'Microsoft Intune', included: false },
  { name: 'Power Apps', included: false },
  { name: 'Power Automate', included: false },
  { name: 'Microsoft 365 Copilot', included: false },
  { name: 'Copilot in Word', included: false },
  { name: 'Copilot in Excel', included: false },
  { name: 'Copilot in PowerPoint', included: false },
  { name: 'Copilot in Outlook', included: false },
  { name: 'Copilot in Teams', included: false },
  { name: 'Work IQ', included: false },
  { name: 'Researcher agent', included: false },
  { name: 'Analyst agent', included: false },
  { name: 'Facilitator agent', included: false },
  { name: 'Agent Builder and Copilot Studio', included: false },
  { name: 'Copilot connectors', included: false },
  { name: 'Copilot Cowork', included: false },
];
